
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Banertomumbai() {



    const cardData =
    {
        keyword: '  Baner to Mumbai Cabs',
        heading: 'Skyline Cabs:  Baner to Mumbai Cabs',
        headingDescription: 'Skyline Cabs provides convenient and comfortable Baner to Mumbai Cabs. Whether you’re heading to Mumbai for a business trip, leisure, or airport transfer, our fleet of well-maintained vehicles and experienced drivers ensure a smooth, timely, and safe ride. Enjoy hassle-free travel with our competitive fares, premium amenities, and reliable service. Book your Baner to Mumbai cab with Skyline Cabs today for a seamless and comfortable journey.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Baner to Mumbai Taxi Fare",
      "description": "Skyline Cabs offers clear and competitive taxi fares for Baner to Mumbai trips. Get instant quotes based on your vehicle preference—whether it's a sedan, Ertiga, or Innova—and enjoy transparent pricing with no hidden charges."
    },
    {
      "name": "Baner to Mumbai One Way Cab",
      "description": "Book a one-way cab from Baner to Mumbai with Skyline Cabs for a smooth, convenient, and affordable journey. Choose from a range of vehicle options and enjoy flexible departure times and 24/7 service."
    },
    {
      "name": "Baner to Mumbai Taxi Service",
      "description": "Need a taxi from Baner to Mumbai? Skyline Cabs provides comfortable and safe travel with professional drivers and well-maintained vehicles. Ideal for work commutes, airport transfers, or personal trips."
    },
    {
      "name": "Baner to Mumbai Airport Drop",
      "description": "Get reliable airport drop service from Baner to Mumbai Airport with Skyline Cabs. We offer on-time pickups, knowledgeable drivers, and clean vehicles to ensure you never miss a flight."
    },
    {
      "name": "Baner to Mumbai Airport Cab Service",
      "description": "Skyline Cabs provides trusted airport cab services from Baner to Mumbai. Book a cab for T1, T2, or T3 terminals with our easy online platform or call booking—available 24/7 for your convenience."
    },
    {
      "name": "Baner to Mumbai Ertiga Cab Service",
      "description": "Travel comfortably with Skyline Cabs' Ertiga service from Baner to Mumbai. Ideal for families or small groups, Ertiga offers ample space, AC comfort, and fuel-efficient performance for long journeys."
    },
    {
      "name": "Baner to Mumbai International Airport Cab",
      "description": "Heading to Chhatrapati Shivaji International Airport from Baner? Skyline Cabs ensures a smooth and timely ride with trained drivers and vehicle options like Innova, Ertiga, and sedans to match your needs."
    },
    {
      "name": "Baner to Mumbai Innova Crysta Cab",
      "description": "Experience luxury with our Innova Crysta service from Baner to Mumbai. Skyline Cabs offers top-class comfort, spacious interiors, and a premium ride perfect for corporate, VIP, or family travel."
    },
    {
      "name": "Baner to Mumbai Sedan Cab",
      "description": "Book a sedan cab from Baner to Mumbai with Skyline Cabs for a budget-friendly and comfortable journey. Ideal for solo travelers and couples, our sedans include Swift Dzire, Honda Amaze, and more."
    },
    {
      "name": "Baner to Mumbai Swift Dzire Car",
      "description": "Skyline Cabs offers affordable Swift Dzire rides from Baner to Mumbai. Enjoy AC comfort, smooth handling, and reliable service for both one-way and return journeys."
    },
    {
      "name": "Baner to Mumbai Round Trip",
      "description": "Planning a return journey? Skyline Cabs provides round-trip taxi service from Baner to Mumbai at discounted fares. Book once and enjoy seamless pickup, drop, and flexible return scheduling."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Skyline Cabs’ Ertiga service is also available for Pune to Mumbai routes. Great for family travel, the Ertiga offers ample luggage space and a comfortable ride for long distances."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Need a premium ride from Pune to Mumbai? Choose Skyline Cabs’ Innova service for exceptional comfort, professional drivers, and a hassle-free intercity travel experience."
    },
    {
      "name": "Baner to Mumbai Airport Cabs",
      "description": "Skyline Cabs offers specialized cab services from Baner to Mumbai Airport with real-time tracking, 24x7 support, and fixed pricing. Book online or over a call for a stress-free airport drop."
    },
    {
      "name": "Baner to Airport Cabs Booking Online",
      "description": "Book your Baner to Mumbai Airport cab online with Skyline Cabs in minutes. Our digital platform ensures instant confirmation, transparent pricing, and a variety of vehicle choices to suit your travel needs."
    },
    {
      "name": "Baner to Andheri Cab Booking",
      "description": "Travel from Baner to Andheri with ease by booking a cab with Skyline Cabs. We offer one-way and round-trip services with options like Ertiga, Dzire, and Innova Crysta—perfect for business or family trips."
    },
    {
      "name": "Baner to Borivali Cab Booking",
      "description": "Need to reach Borivali from Baner? Skyline Cabs provides direct cab services with experienced drivers, safe rides, and a fleet of clean, comfortable vehicles. Book in advance or on-demand."
    },
    {
      "name": "Baner to Mumbai Central Cab",
      "description": "Get a direct cab from Baner to Mumbai Central Station with Skyline Cabs. Ideal for railway station drops and pickups, our service is available 24/7 with easy booking and fixed fares."
    },
    {
      "name": "Baner to Bandra Cab",
      "description": "Skyline Cabs offers reliable cab service from Baner to Bandra. Whether you're traveling for work, shopping, or social visits, we ensure timely service, comfort, and upfront pricing."
    },
    {
      "name": "Baner to Dadar Cabs",
      "description": "Book a cab from Baner to Dadar with Skyline Cabs. Enjoy a smooth ride across the city with options like Ertiga, Dzire, or Innova for maximum comfort and safety."
    },
    {
      "name": "Skyline Cabs",
      "description": "Skyline Cabs is your trusted partner for intercity and airport travel in and around Pune. We serve Baner, PCMC, Kothrud, Viman Nagar, and more, offering 24x7 bookings, professional drivers, and excellent customer service."
    },
    {
      "name": "Cab Service in Pune",
      "description": "From city tours to airport transfers, Skyline Cabs offers a complete cab service in Pune. Whether you're traveling within the city or planning an outstation trip to Mumbai, our fleet and service meet all needs."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Book your Pune to Mumbai Airport cab with Skyline Cabs for a smooth, punctual, and affordable ride. We serve all areas including Baner and ensure timely drops to all terminals of Mumbai Airport."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs offers seamless cab service between Pune and Mumbai. With flexible booking, multiple vehicle options, and experienced drivers, we make intercity travel easy and comfortable."
    }
  ],
  "tableData": [
    ["Baner to Mumbai Taxi Fare", "-Baner to Mumbai One Way Cab"],
    ["Baner to Mumbai Taxi Service", "-Baner to Mumbai Airport Drop"],
    ["Baner to Mumbai Airport Cab Service", "-Baner to Mumbai Ertiga Cab Service"],
    ["Baner to Mumbai International Airport Cab", "-Baner to Mumbai Innova Crysta Cab"],
    ["Baner to Mumbai Sedan Cab", "-Baner to Mumbai Swift Dzire Car"],
    ["Baner to Mumbai Round Trip", "-Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "-Baner to Mumbai Airport Cabs"],
    ["Baner to Airport Cabs Booking Online", "-Baner to Andheri Cab Booking"],
    ["Baner to Borivali Cab Booking", "-Baner to Mumbai Central Cab"],
    ["Baner to Bandra Cab", "-Baner to Dadar Cabs"],
    ["Skyline Cabs", "-Cab Service in Pune"],
    ["Pune to Mumbai Airport Cab", "-Pune Mumbai Cab"]
  ],



whychoose: [
    {
        "WhyChooseheading": "Reliable Baner to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides prompt and reliable cab services from Baner to Mumbai. Whether it’s a business meeting, a family visit, or catching a flight, we ensure you reach your destination on time with complete peace of mind."
    },
    {
        "WhyChooseheading": "Comfortable Cabs for Every Travel Need",
        "WhyChoosedescription": "Travel in comfort from Baner to Mumbai in our well-maintained, spacious cabs. With options ranging from sedans to SUVs and premium vehicles, our rides are designed to suit every budget and travel style, with enough space for passengers and luggage."
    },
    {
        "WhyChooseheading": "Professional Drivers with Local Expertise",
        "WhyChoosedescription": "Our courteous and experienced drivers know the best routes from Baner to Mumbai, helping you avoid traffic and reach faster. They are well-trained in safe driving and are committed to providing you a smooth, stress-free journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive pricing for all Baner to Mumbai routes with complete transparency. No hidden charges, no surprises—just fair, upfront fares that let you plan your trip with confidence."
    },
    {
        "WhyChooseheading": "24/7 Availability for Baner to Mumbai Cabs",
        "WhyChoosedescription": "No matter what time of day you need to travel, Skyline Cabs is ready. Our services are available 24/7, making it easy for you to book a cab at your convenience—even for early morning flights or late-night returns."
    },
    {
        "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
        "WhyChoosedescription": "Booking your cab from Baner to Mumbai is quick and simple. Use our website or mobile app to select your ride, view fare estimates, and get instant confirmation. It’s a seamless process that puts you in control of your travel."
    },
    {
        "WhyChooseheading": "Well-Maintained Vehicles for a Smooth Ride",
        "WhyChoosedescription": "All Skyline Cabs are regularly serviced and cleaned to ensure your comfort and safety. You’ll experience a smooth ride with features like air-conditioning, clean interiors, and smooth handling for the entire trip from Baner to Mumbai."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel with Verified Drivers",
        "WhyChoosedescription": "Your safety is our top priority. All our drivers are background-checked, and every vehicle is GPS-enabled for real-time tracking. Whether you're booking for yourself or a loved one, you can trust Skyline Cabs for a secure journey."
    }
]








    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Baner to Mumbai with Skyline Cabs?',
            answer:
                'Booking your cab is quick and simple! Visit our website, use the Skyline Cabs mobile app, or call our customer support. Enter your Baner pickup and Mumbai drop location, choose a vehicle, and confirm instantly.',
        },
        {
            id: 2,
            question: 'What kind of vehicles are available for Baner to Mumbai travel?',
            answer:
                'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars. Whether you’re traveling solo or with a group, we have a car that fits your needs.',
        },
        {
            id: 3,
            question: 'Is the Baner to Mumbai cab fare fixed or based on distance?',
            answer:
                'Skyline Cabs offers fixed pricing for Baner to Mumbai routes. No hidden charges — tolls and applicable taxes are shared clearly at the time of booking.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round-trip cab from Baner to Mumbai?',
            answer:
                'Yes, you can book both one-way and round-trip cabs. Just select your travel type and timing while booking, and we’ll take care of the rest.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Baner to Mumbai?',
            answer:
                'The journey from Baner to Mumbai usually takes 2.5 to 3.5 hours depending on traffic conditions. Our drivers are experienced and will ensure timely arrival.',
        },
        {
            id: 6,
            question: 'Are Skyline Cabs drivers experienced and reliable?',
            answer:
                'Absolutely! All our drivers are background-verified, experienced in long-distance routes, and trained in customer service to give you a safe, pleasant experience.',
        },
        {
            id: 7,
            question: 'Can I schedule a Baner to Mumbai cab in advance?',
            answer:
                'Yes, advance bookings are encouraged, especially during peak hours or weekends. You can schedule your ride as per your convenience through our app or website.',
        },
        {
            id: 8,
            question: 'Is airport drop from Baner to Mumbai available?',
            answer:
                'Yes, we provide cab services from Baner to Mumbai International and Domestic Airports. Just mention your flight details for on-time drop-off.',
        },
        {
            id: 9,
            question: 'Do you offer customer support for online bookings?',
            answer:
                'Yes, our customer support team is available 24/7 to assist you with bookings, modifications, and any trip-related queries.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Baner to Mumbai cab service?',
            answer:
                'Skyline Cabs offers clean cars, professional drivers, on-time service, and transparent pricing. We’re trusted by thousands for comfortable city-to-city travel.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Kunal Joshi",
            rating: 5,
            review: "Skyline Cabs made my trip from Baner to Mumbai super convenient. The driver was courteous, arrived on time, and the car was in top condition. The booking experience was smooth, and there were no surprise charges."
        },
        {
            name: "Miss. Prachi Wagh",
            rating: 4,
            review: "I booked a one-way cab from Baner to Mumbai for a family visit. The cab was clean and the ride was smooth. The only thing I’d suggest is better music options in the car – but otherwise, great service!"
        },
    ];
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Baner to Mumbai Cabs",
  "image": "https://skylinecabs.com/assets/images/baner-to-mumbai-cabs.jpg",
  "description": "Book Baner to Mumbai cabs with Skyline Cabs for affordable, comfortable, and safe taxi travel. Choose AC sedans, SUVs, or premium cars with professional drivers—available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7732"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/baner-to-mumbai-cabs"
  }
};



      
  


    return (
        <div>
    <Helmet>
  <title>Baner to Mumbai Cabs | 24/7 Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Baner to Mumbai cabs with Skyline Cabs for affordable, comfortable, and safe taxi travel. Choose AC sedans, SUVs, or premium cars with professional drivers—available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Baner to Mumbai Cabs, Cab from Baner to Mumbai, One-Way Taxi Baner to Mumbai, Round Trip Cab Baner to Mumbai, AC Cab Baner to Mumbai, SUV Taxi Baner to Mumbai, Baner to Mumbai Cab Booking, Online Taxi Baner to Mumbai, Skyline Cabs Baner Mumbai, 24/7 Baner to Mumbai Cabs" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/9.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Banertomumbai;